import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from 'react-redux';
import api from "../../../api/index";
import AvatarSection from "./avatarSection";
import { useNavigate } from "react-router-dom";
import { getAvatar, getGroupByPlayer } from '../gameSlice';
import { getUserColor } from '../../../utils/index';
import "./avatarDesigner.css";
import { useTranslation } from 'react-i18next';
import { gsap, Elastic } from "gsap/all";
import useDisableBrowserBack from "../../hooks/useDisableBrowserBack";
import useReadCookies from "../../hooks/useReadCookies";


function AvatarDesigner() {
  useDisableBrowserBack();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [avatars, setAvatars] = useState(false);
  const [currentTop, setCurrentTop] = useState(0);
  const [currentMid, setCurrentMid] = useState(0);
  const [currentBottom, setCurrentBottom] = useState(0);
  const currentAvatar = useSelector((state) => state.game.avatar);
  const [firstAvatarLoaded, setFirstAvatarLoaded] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const players = useSelector((state) => state.game.players);

  let { cookieGameId, cookiePlayerId, cookieUsername, cookieGroupId } = useReadCookies();

  useEffect(() => {
    dispatch(getGroupByPlayer(cookiePlayerId));

    api.getAvatarSettings().then((response) => {
      if (response.status === 200) {
        const data = response.data;
        setAvatars(data);
        console.log(data);
      }
    });

    const interval = setInterval(() => {
      dispatch(getAvatar(cookieGroupId));
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (currentAvatar && avatars) {
      if (currentAvatar.top_player === cookiePlayerId && firstAvatarLoaded === false) {
        setFirstAvatarLoaded(true);
        avatars.tops.forEach((top, index) => {
          if (top.id === currentAvatar.top_id) {
            setCurrentTop(index);
          }
        });
      } else if (currentAvatar.top_player !== cookiePlayerId) {
        avatars.tops.forEach((top, index) => {
          if (top.id === currentAvatar.top_id) {
            setCurrentTop(index);
          }
        });
      }

      if (currentAvatar.mid_player === cookiePlayerId && firstAvatarLoaded === false) {
        setFirstAvatarLoaded(true);
        avatars.mids.forEach((mid, index) => {
          if (mid.id === currentAvatar.mid_id) {
            setCurrentMid(index);
          }
        });
      } else if (currentAvatar.mid_player !== cookiePlayerId) {
        avatars.mids.forEach((mid, index) => {
          if (mid.id === currentAvatar.mid_id) {
            setCurrentMid(index);
          }
        });
      }

      if (currentAvatar.bottom_player === cookiePlayerId && firstAvatarLoaded === false) {
        setFirstAvatarLoaded(true);
        avatars.bottoms.forEach((bottom, index) => {
          if (bottom.id === currentAvatar.bottom_id) {
            setCurrentBottom(index);
          }
        });
      } else if (currentAvatar.bottom_player !== cookiePlayerId) {
        avatars.bottoms.forEach((bottom, index) => {
          if (bottom.id === currentAvatar.bottom_id) {
            setCurrentBottom(index);
          }
        });
      }
    }

    if (currentAvatar && currentAvatar.top_player === cookiePlayerId && currentAvatar.top_player_confirmed) {
      setIsSubmitting(true);
    }
    if (currentAvatar && currentAvatar.mid_player === cookiePlayerId && currentAvatar.mid_player_confirmed) {
      setIsSubmitting(true);
    }
    if (currentAvatar && currentAvatar.bottom_player === cookiePlayerId && currentAvatar.bottom_player_confirmed) {
      setIsSubmitting(true);
    }

    if (currentAvatar && currentAvatar.top_player_confirmed && currentAvatar.mid_player_confirmed && currentAvatar.bottom_player_confirmed) {
      navigate(`/app/game/roles/${cookieGameId}${window.location.search}`);
    }
    // dispatch(getAvatar(cookieGroupId));
  }, [currentAvatar, avatars]);

  useEffect(() => {
    saveAvatar('top', currentTop);
  }, [currentTop]);

  useEffect(() => {
    saveAvatar('mid', currentMid);
  }, [currentMid]);

  useEffect(() => {
    saveAvatar('bottom', currentBottom);
  }, [currentBottom]);

  const updateAvatar = () => {
    let section = "";
    let currentIndex = -1;
    if (currentAvatar && cookiePlayerId === currentAvatar.top_player) {
      section = "top";
      currentIndex = currentTop;
    } else if (currentAvatar && cookiePlayerId === currentAvatar.mid_player) {
      section = "mid";
      currentIndex = currentMid;
    } else if (currentAvatar && cookiePlayerId === currentAvatar.bottom_player) {
      section = "bottom";
      currentIndex = currentBottom;
    }

    setIsSubmitting(true);
    if (currentIndex < 0)
      return;
    let avatarId = 0;
    if (avatars) {
      if (section === 'top' && avatars.tops.length > currentIndex) {
        avatarId = avatars.tops[currentIndex].id;
      } else if (section === 'mid' && avatars.mids.length > currentIndex) {
        avatarId = avatars.mids[currentIndex].id;
      } else if (section === 'bottom' && avatars.bottoms.length > currentIndex) {
        avatarId = avatars.bottoms[currentIndex].id;
      }

      if (avatarId) {
        api.updateAvatar(cookieGroupId, avatarId, section).then((response) => {
          if (response.status === 200) {
            const data = response.data;
          }
        });
      }
    }
  };

  const saveAvatar = (section, currentIndex) => {
    if (currentIndex < 0)
      return;
    let avatarId = 0;
    if (avatars) {
      if (section === 'top' && avatars.tops.length > currentIndex) {
        avatarId = avatars.tops[currentIndex].id;
      } else if (section === 'mid' && avatars.mids.length > currentIndex) {
        avatarId = avatars.mids[currentIndex].id;
      } else if (section === 'bottom' && avatars.bottoms.length > currentIndex) {
        avatarId = avatars.bottoms[currentIndex].id;
      }

      if (avatarId) {
        api.saveAvatar(cookieGroupId, avatarId, section).then((response) => {
          if (response.status === 200) {
            const data = response.data;
          }
        });
      }
    }
  };
  const getUserNameByPosition = (position) => {
    if (currentAvatar && players) {
      if (position === 'top') {
        for (let i = 0; i < players.length; i++) {
          if (players[i].secret === currentAvatar.top_player) {
            let name = cookiePlayerId === players[i].secret ? t("student.questions_overview.you") : players[i].name;
            return name;
          }
        }

      } else if (position === 'mid') {
        for (let i = 0; i < players.length; i++) {
          if (players[i].secret === currentAvatar.mid_player) {
            let name = cookiePlayerId === players[i].secret ? t("student.questions_overview.you") : players[i].name;
            return name;
          }
        }
      } else if (position === 'bottom') {
        for (let i = 0; i < players.length; i++) {
          if (players[i].secret === currentAvatar.bottom_player) {
            let name = cookiePlayerId === players[i].secret ? t("student.questions_overview.you") : players[i].name;
            return name;
          }
        }
      }
    }
    return "";
  }

  const getColorByUser = (position) => {
    if (currentAvatar) {
      if (position === 'top') {
        return getUserColor(currentAvatar.top_player);
      } else if (position === 'mid') {
        return getUserColor(currentAvatar.mid_player);
      } else if (position === 'bottom') {
        return getUserColor(currentAvatar.bottom_player);
      }
    }
    return "#f2f2f2";
  }

  const handleBackButton = e => {
    e.preventDefault();
    setTimeout(() => {
      navigate(`/app/game/register/${cookieGameId}${window.location.search}`)
    }, 500);

  };

  useEffect(() => {
    dispatch(getAvatar(cookieGroupId));
    if (avatars) {
      //data loaded
    }
  }, [avatars])

  return (
    <div className="mobileContainer backgroundGold create-avatar-screen">
      <div className="create-avatar-wrapper">
        <div className="title-wrapper">
          <h3>{t("student.avatar.title")}</h3>
        </div>
        <div className="avatar-module-wrapper">
          <div className="ground-strip"></div>
          {avatars &&
            <>
              <AvatarSection
                sectionIndex={2}
                sectionData={avatars['bottoms']}
                isDisabled={currentAvatar && (cookiePlayerId !== currentAvatar.bottom_player || currentAvatar.bottom_player_confirmed)}
                currentSelection={currentBottom}
                setCurrentSelection={setCurrentBottom}
                isSubmitting={isSubmitting} 
                playerName={getUserNameByPosition('bottom')} 
                userColor={getColorByUser('bottom')}
                sectionClassName={'bottoms'}/>
              <AvatarSection
                sectionIndex={0}
                sectionData={avatars['tops']}
                isDisabled={currentAvatar && (cookiePlayerId !== currentAvatar.top_player || currentAvatar.top_player_confirmed)}
                currentSelection={currentTop}
                setCurrentSelection={setCurrentTop}
                isSubmitting={isSubmitting} 
                playerName={getUserNameByPosition('top')} 
                userColor={getColorByUser('top')}
                sectionClassName={'tops'}/>
              <AvatarSection
                sectionIndex={1}
                sectionData={avatars['mids']}
                isDisabled={currentAvatar && (cookiePlayerId !== currentAvatar.mid_player || currentAvatar.mid_player_confirmed)}
                currentSelection={currentMid}
                setCurrentSelection={setCurrentMid}
                isSubmitting={isSubmitting} 
                playerName={getUserNameByPosition('mid')} 
                userColor={getColorByUser('mid')}
                sectionClassName={'mids'}/>
            </>
          }
        </div>
        <div className={`navigationDrawer spread variant6 enableInAnimation`}>
          <a className="chromelessIconButton" onClick={handleBackButton}>
            <span className="icon icon-backward-simple"></span>
          </a>
          <button type="submit" className={`chromelessIconButton ${isSubmitting ? 'disabled' : ''}`} onClick={updateAvatar} disabled={isSubmitting}>
            <span className="caption">{t("student.game_code.continue_button")}</span>
            <span className={`icon ${isSubmitting ? 'icon-forward-simple' : 'icon-forward'}`}></span>
          </button>
        </div>
      </div>
    </div>
  )

  /*
    useDisableBrowserBack();
    const dispatch = useDispatch();
    
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [showAvatarPopup, setShowAvatartPopup] = useState(true);
    const [avatars, setAvatars] = useState(false);
    const currentAvatar = useSelector((state) => state.game.avatar);
    const players = useSelector((state) => state.game.players);
    const [currentTop, setCurrentTop] = useState(0);
    const [currentMid, setCurrentMid] = useState(0);
    const [currentBottom, setCurrentBottom] = useState(0);
    const [firstAvatarLoaded, setFirstAvatarLoaded] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isPopupButtonClicked, setIsPopupButtonClicked] = useState(false);

    let { cookieGameId, cookiePlayerId, cookieUsername, cookieGroupId } = useReadCookies();

    // animations
    let contentRef = useRef(null);
    let lionRef = useRef(null);
    let helpRef = useRef(null);
    let messageRef = useRef(null);
    let controlbarRef = useRef(null);

    const [animation, setAnimation] = useState(null);
    const [popupAnimation, setPopupAnimation] = useState(null);

    useEffect(() => {
        document.querySelector('meta[name="theme-color"]').setAttribute('content',  '#2b2b2b');

        dispatch(getGroupByPlayer(cookiePlayerId));
        
        api.getAvatarSettings().then((response) => {
            if (response.status === 200) {
                const data = response.data;
                setAvatars(data);
                console.log(data);
            }
        });

        setPopupAnimation(gsap.timeline()
            .fromTo(messageRef, { opacity: 0, y: -600}, {opacity: 1, y: 0, duration: 0.5, ease: Elastic.easeOut(1, 0.3)})
            .fromTo(lionRef, { opacity: 0, x: -300}, {opacity: 1, x: 0, duration: 0.5, ease: Elastic.easeOut(1, 0.3)})
            .fromTo(helpRef, { opacity: 0, x: -400}, {opacity: 1, x: 0, duration: 0.5, ease: Elastic.easeOut(1, 0.3)})
        );

        // polling for group status every 5 seconds until group is confirmed  
        const interval = setInterval(() => {
        dispatch(getAvatar(cookieGroupId));
      } , 2000); 

      return () => clearInterval(interval);

      

    }, []);

    useEffect(() => {
        dispatch(getAvatar(cookieGroupId));
    }, [avatars]);

    useEffect(() => {
            if (currentAvatar && avatars) {
                if(currentAvatar.top_player === cookiePlayerId && firstAvatarLoaded === false) {
                    setFirstAvatarLoaded(true);
                    avatars.tops.forEach((top, index) => {
                        if (top.id === currentAvatar.top_id) {
                            setCurrentTop(index);
                        }
                    });
                }else if(currentAvatar.top_player !== cookiePlayerId) {
                    avatars.tops.forEach((top, index) => {
                        if (top.id === currentAvatar.top_id) {
                            setCurrentTop(index);
                        }
                    });
                }
                
                if(currentAvatar.mid_player === cookiePlayerId && firstAvatarLoaded === false) {
                    setFirstAvatarLoaded(true);
                    avatars.mids.forEach((mid, index) => {
                        if (mid.id === currentAvatar.mid_id) {
                            setCurrentMid(index);
                        }
                    });
                }else if(currentAvatar.mid_player !== cookiePlayerId) {
                    avatars.mids.forEach((mid, index) => {
                        if (mid.id === currentAvatar.mid_id) {
                            setCurrentMid(index);
                        }
                    });
                }
                
                if(currentAvatar.bottom_player === cookiePlayerId && firstAvatarLoaded === false) {
                    setFirstAvatarLoaded(true);
                    avatars.bottoms.forEach((bottom, index) => {
                        if (bottom.id === currentAvatar.bottom_id) {
                            setCurrentBottom(index);
                        }
                    });
                }else if(currentAvatar.bottom_player !== cookiePlayerId) {
                    avatars.bottoms.forEach((bottom, index) => {
                        if (bottom.id === currentAvatar.bottom_id) {
                            setCurrentBottom(index);
                        }
                    });
                }
                
            }

            if(currentAvatar && currentAvatar.top_player === cookiePlayerId && currentAvatar.top_player_confirmed){
                setIsSubmitting(true);
            }
            if(currentAvatar && currentAvatar.mid_player === cookiePlayerId && currentAvatar.mid_player_confirmed){
                setIsSubmitting(true);
            }
            if(currentAvatar && currentAvatar.bottom_player === cookiePlayerId && currentAvatar.bottom_player_confirmed){
                setIsSubmitting(true);
            }

            if(currentAvatar && currentAvatar.top_player_confirmed && currentAvatar.mid_player_confirmed && currentAvatar.bottom_player_confirmed){
                navigate(`/app/game/roles/${cookieGameId}${window.location.search}`);
            }
        // dispatch(getAvatar(cookieGroupId));
    }, [currentAvatar, avatars]);

    useEffect(() => {
            saveAvatar('top', currentTop);
    }, [currentTop]);

    useEffect(() => {
        saveAvatar('mid', currentMid);
    }, [currentMid]);

    useEffect(() => {
        saveAvatar('bottom', currentBottom);
    }, [currentBottom]);

    const updateAvatar = () => {
        let section = "";
        let currentIndex = -1;
        if(currentAvatar && cookiePlayerId === currentAvatar.top_player){
            section = "top";
            currentIndex = currentTop;
        }else if (currentAvatar && cookiePlayerId === currentAvatar.mid_player){
            section = "mid";
            currentIndex = currentMid;
        }else if (currentAvatar && cookiePlayerId === currentAvatar.bottom_player){
            section = "bottom";
            currentIndex = currentBottom;
        }

        setIsSubmitting(true);
        if(currentIndex < 0)
            return;
        let avatarId = 0;
        if(avatars){
            if(section === 'top' && avatars.tops.length > currentIndex) {
                avatarId = avatars.tops[currentIndex].id;
            }else if(section === 'mid' && avatars.mids.length > currentIndex) {
                avatarId = avatars.mids[currentIndex].id;
            }else if(section === 'bottom' && avatars.bottoms.length > currentIndex) {
                avatarId = avatars.bottoms[currentIndex].id;
            }

            if(avatarId){
                api.updateAvatar(cookieGroupId, avatarId, section).then((response) => {
                    if (response.status === 200) {
                        const data = response.data;
                    }
                });
            }
        }
    };

    const saveAvatar = (section, currentIndex) => {
        if(currentIndex < 0)
            return;
        let avatarId = 0;
        if(avatars){
            if(section === 'top' && avatars.tops.length > currentIndex) {
                avatarId = avatars.tops[currentIndex].id;
            }else if(section === 'mid' && avatars.mids.length > currentIndex) {
                avatarId = avatars.mids[currentIndex].id;
            }else if(section === 'bottom' && avatars.bottoms.length > currentIndex) {
                avatarId = avatars.bottoms[currentIndex].id;
            }

            if(avatarId){
                api.saveAvatar(cookieGroupId, avatarId, section).then((response) => {
                    if (response.status === 200) {
                        const data = response.data;
                    }
                });
            }
        }

      };

    const hidePopup = () => {
        setIsPopupButtonClicked(true);
        popupAnimation.reverse();
        const timelineDuration = popupAnimation.duration() * 1000;
        setTimeout(()=>{
            setShowAvatartPopup(false);
            setIsPopupButtonClicked(false);
            setAnimation(gsap.timeline()
                .fromTo(controlbarRef.current, { opacity: 1, y: 300}, {opacity: 1, y: 0, duration: 0.5, ease: Elastic.easeOut(1, 0.3)})
                .fromTo(contentRef.current, { opacity: 0}, {opacity: 1})
            );
        }, timelineDuration);
        
    };

    const backButtonHandle = e => {
        e.preventDefault();
        animation.reverse();
        const timelineDuration = animation.duration() * 1000;
        setTimeout(()=>{
            navigate(`/app/game/register/${cookieGameId}${window.location.search}`)
        }, timelineDuration);
        
    };

    const getUserNameByPosition = (position) => {
        if(currentAvatar && players){
            if(position === 'top'){
                for(let i = 0; i < players.length; i++){
                    if(players[i].secret === currentAvatar.top_player){
                        let name = cookiePlayerId === players[i].secret ? t("student.questions_overview.you") : players[i].name;
                        return name;
                    }
                }

            } else if(position === 'mid'){
                for(let i = 0; i < players.length; i++){
                    if(players[i].secret === currentAvatar.mid_player){
                        let name = cookiePlayerId === players[i].secret ? t("student.questions_overview.you") : players[i].name;
                        return name;
                    }
                }
            } else if(position === 'bottom'){
               for(let i = 0; i < players.length; i++){
                    if(players[i].secret === currentAvatar.bottom_player){
                        let name = cookiePlayerId === players[i].secret ? t("student.questions_overview.you") : players[i].name;
                        return name;
                    }
                }
            }
        }
        return "";
    }

    const getColorByUser = (position) => {
        if(currentAvatar){
            if(position === 'top') {
                return getUserColor(currentAvatar.top_player);
            } else if(position === 'mid') {
                return getUserColor(currentAvatar.mid_player);
            } else if(position === 'bottom') {
                return getUserColor(currentAvatar.bottom_player);
            }
        }
        return "#f2f2f2";
    }

    return (
        <div className="mobile-container avatar-screen">
            <div className="content-wrapper" ref={contentRef}>
                <h3>{t("student.avatar.title")}</h3>
                <div className="avatar-section-wrapper">
                <AvatarSection 
                    items={avatars.tops} 
                    position={'top'}
                    currentIndex={currentTop} 
                    setCurrentIndex={setCurrentTop} 
                    playerName={getUserNameByPosition('top')} 
                    confirmed={ currentAvatar && currentAvatar.top_player_confirmed} 
                    userColor={getColorByUser('top')}
                    disabled={currentAvatar && (cookiePlayerId !== currentAvatar.top_player || currentAvatar.top_player_confirmed)}
                    currentPlayer={currentAvatar && cookiePlayerId === currentAvatar.top_player}
                />
                <AvatarSection 
                    items={avatars.bottoms} 
                    position={'bottom'}
                    currentIndex={currentBottom} 
                    setCurrentIndex={setCurrentBottom} 
                    playerName={getUserNameByPosition('bottom')} 
                    confirmed={ currentAvatar && currentAvatar.bottom_player_confirmed} 
                    userColor={getColorByUser('bottom')}
                    disabled={currentAvatar && (cookiePlayerId !== currentAvatar.bottom_player || currentAvatar.bottom_player_confirmed)}
                    currentPlayer={currentAvatar && cookiePlayerId === currentAvatar.bottom_player}
                />
                <AvatarSection 
                    items={avatars.mids} 
                    position={'mid'}
                    currentIndex={currentMid} 
                    setCurrentIndex={setCurrentMid} 
                    playerName={getUserNameByPosition('mid')} 
                    confirmed={ currentAvatar && currentAvatar.mid_player_confirmed} 
                    userColor={getColorByUser('mid')}
                    disabled={currentAvatar &&  (cookiePlayerId !== currentAvatar.mid_player || currentAvatar.mid_player_confirmed)}
                    currentPlayer={currentAvatar && cookiePlayerId === currentAvatar.mid_player}
                />
                </div>
                
                
            </div>
            <div className="control-panel" ref={controlbarRef}>
                <a className="back" href="" onClick={backButtonHandle}>
                    <svg width="14" height="21" viewBox="0 0 14 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 1.5L3 10.5L12 19.5" stroke="white" strokeWidth="4"/>
                    </svg>
                </a>
                <button type="submit" className={`continue-button ${isSubmitting ? 'invalid' : ''}`}  onClick={updateAvatar} disabled={isSubmitting}>
                    <div className="label">{t("student.avatar.continue_button")}</div>
                    <div className="arrow">
                        <svg width="14" height="21" viewBox="0 0 14 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 1.5L11 10.5L2 19.5" stroke={`${ isSubmitting ? '#183060': 'white'}`} strokeWidth="4"/>
                        </svg>
                    </div>
                </button>
            </div>
            <div className={`avatar-message-wrapper ${showAvatarPopup ? 'show' : ''}`}>
                <div className="avatar-message" ref={e => {messageRef = e}}>
                    <h3>{t("student.avatar.message_title")}</h3>
                    <p>{t('student.avatar.message', {nickname: cookieUsername})}</p>
                    <div className="help" ref={e => {helpRef = e}}>
                        <p>{t("student.avatar.help")}</p>
                    </div>
                    <button className={`button ${isPopupButtonClicked ? 'invalid' : ''}`}  onClick={hidePopup}>{t("student.avatar.message_button")}</button>
                    <div className="lion" ref={e => {lionRef = e}}>
                        <img src="/images/lion.png" width={218} height={216} />
                    </div>
                </div>
                
            </div>
        </div>
    );*/
}

export default AvatarDesigner;
